import { h } from 'preact';
import React from 'react';

import { PreloadContext } from './contexts';
import { getParameterByName, observeCLS, getValidOrigin } from './util';
import { CCPA_ORIGIN, CMPV2_ORIGIN } from './constants';

import './style.css';

if (getParameterByName('observe_cls') === "true") {
  observeCLS(); 
}

const injectQueryParams = (Component) => (props) => (
  <PreloadContext.Provider value={ getParameterByName('preload_message') }>
    <Component
      {...props}
      messageId={getParameterByName('message_id')}
      dev={getParameterByName('type') === 'dev'}
      mini={getParameterByName('type') === 'mini'}
      tiny={getParameterByName('type') === 'tiny'}
      full={getParameterByName('type') === 'full'}
      ccpaType={getParameterByName('ccpa_type')}
      accountId={getParameterByName('account_id') || 22}
      ccpaOrigin={getValidOrigin('ccpa_origin')}
      usnatOrigin={getValidOrigin('usnat_origin')}
      usnatOriginBuilder={getValidOrigin('usnat_origin_builder')}
      cmpv2Origin={getValidOrigin('consent_origin') || getValidOrigin('cmpv2_origin') || CMPV2_ORIGIN}
      consentUUID={getParameterByName('consentUUID') || undefined}
      ccpaUUID={getParameterByName('ccpaUUID') || undefined}
      uuid={getParameterByName('uuid') || undefined}
      requestUUID={getParameterByName('requestUUID') || undefined}
      mmsOrigin={getValidOrigin('mms_origin')}
      siteId={getParameterByName('site_id')}
      requestId={getParameterByName('request_id')}
      preloadMsg={getParameterByName('preload_message')}
      preloadConsent={getParameterByName('preload_consent')}
      pmTab={getParameterByName('pmTab')}
      consentLanguage={ (getParameterByName('consentLanguage') || '').toUpperCase() || null}
      idfaStatus={getParameterByName('idfaStatus')}
      isCcpa={getParameterByName('is_ccpa')}
      isUsnatNotice={getParameterByName('is_usnat_notice')}
      currentView={getParameterByName('view')}
    />
  </PreloadContext.Provider>
);

export default injectQueryParams;